"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Gallery = require("./Gallery.styles");

var _Gallery2 = require("./Gallery.types");

var GalleryImage = function GalleryImage(_ref) {
  var image = _ref.image,
      isLoaded = _ref.isLoaded,
      placeholder = _ref.placeholder,
      productInfo = _ref.productInfo,
      showDescription = _ref.showDescription,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement(_Gallery.ImageWrapper, null, /*#__PURE__*/_react["default"].createElement(_Gallery.ImagePicture, {
    theme: theme
  }, image.sizes && Object.keys(image.sizes).map(function (size) {
    return /*#__PURE__*/_react["default"].createElement("source", {
      media: "(min-width: ".concat(size, ")"),
      key: "gallery-image-source-".concat(size),
      srcSet: isLoaded ? image.sizes[size] : placeholder
    });
  }), /*#__PURE__*/_react["default"].createElement(_Gallery.Image, {
    theme: theme,
    src: isLoaded ? image.primaryLink : placeholder,
    alt: "".concat(productInfo.siteProductName, " - ").concat(image.description)
  })), showDescription && image.description && /*#__PURE__*/_react["default"].createElement(_Gallery.ImageCaption, null, image.description));
};

GalleryImage.propTypes = {
  image: _Gallery2.imageShape.isRequired,
  isLoaded: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  productInfo: _Gallery2.productInfoShape,
  showDescription: _propTypes["default"].bool,
  theme: _Gallery2.galleryTheme
};
GalleryImage.defaultProps = {
  isLoaded: false,
  placeholder: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
  productInfo: {},
  showDescription: false,
  theme: undefined
};
GalleryImage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GalleryImage",
  "props": {
    "isLoaded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "productInfo": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "productInfoShape"
      },
      "required": false
    },
    "showDescription": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "galleryTheme"
      },
      "required": false
    },
    "image": {
      "description": "",
      "type": {
        "name": "custom",
        "raw": "imageShape.isRequired"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(GalleryImage);

exports["default"] = _default;